import { render } from "./IDPGameTargets.vue?vue&type=template&id=801eb308&scoped=true"
import script from "./IDPGameTargets.vue?vue&type=script&lang=js"
export * from "./IDPGameTargets.vue?vue&type=script&lang=js"

import "./IDPGameTargets.vue?vue&type=style&index=0&id=801eb308&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801eb308"]])

export default __exports__